/**
 * @author vishwadeep.kapoor
 * Selectors for HeaderContainer
 *
 */

import { createSelector } from 'reselect';
import { utils } from '../../devUtils';

const selectHeaderContainerDomain = (state) => state.get('headerContainer');

const selectHeaderContainer = () => createSelector(
  selectHeaderContainerDomain,
  (headerContainerState) => headerContainerState,
);

const selectUserDetails = () => createSelector(
  selectHeaderContainerDomain,
  (headerContainerState) => utils.immutableToJS(headerContainerState.get('userDetails')),
);

const selectLoggedIn = () => createSelector(
  selectHeaderContainerDomain,
  (headerContainerState) => headerContainerState.get('loggedIn'),
);

const selectCity = () => createSelector(selectHeaderContainerDomain,
  (headerContainerState) => utils.immutableToJS(headerContainerState.get('selectedCity')),
);

const getDefaultError = () => createSelector(selectHeaderContainerDomain,
  (headerContainerState) => utils.immutableToJS(headerContainerState.get('apiResonse')),
);

const getSearchType = () => createSelector(selectHeaderContainerDomain,
  (headerContainerState) => utils.immutableToJS(headerContainerState.get('search')),
);

const isLoading = () => createSelector(selectHeaderContainerDomain,
  (headerContainerState) => headerContainerState.get('isLoading'),
);

const isMobileScreen = () => createSelector(selectHeaderContainerDomain,
  (headerContainerState) => headerContainerState.get('isMobileScreen'),
);

const getEvocherOtp = () => createSelector(selectHeaderContainerDomain,
  (headerContainerState) => utils.immutableToJS(headerContainerState.get('evocherOtp')),
);

const selectHeaderContainerJS = (key) => createSelector(
  selectHeaderContainerDomain,
  (headerContainerState) => utils.immutableToJS(headerContainerState.get(key)),
);

export {
  selectHeaderContainer,
  selectUserDetails,
  selectLoggedIn,
  selectCity,
  getDefaultError,
  getSearchType,
  isLoading,
  isMobileScreen,
  getEvocherOtp,
  selectHeaderContainerJS,
};



// WEBPACK FOOTER //
// client/containers/HeaderContainer/selectors.js